import useApi from "../../api/useApi";

const useSpotGroupSpotsService = () => {

  const {api} = useApi()

  const userSpotMapShow = (callbackSuccess, callbackValidationErrors, spotGroupId, data) => {
    return api(
      'get',
      'user/spot_group/' + spotGroupId + '/spot_map/show',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useSpotGroupSpotsService::userSpotMapShow: ${error?.message || JSON.stringify(error)}`)},
      data,
    )
  }

  const userSpotMapUpdate = (callbackSuccess, callbackValidationErrors, spotGroupId, data) => {
    return api(
      'post',
      'user/spot_group/' + spotGroupId + '/spot_map/update',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useSpotGroupSpotsService::userSpotMapUpdate: ${error?.message || JSON.stringify(error)}`)},
      data,
    )
  }

  return {
    objectType: 'spot_group_spots',
    userSpotMapShow,
    userSpotMapUpdate,
  }
}

export default useSpotGroupSpotsService
